import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'
import Step from './Step'

/*
 * This component is used to display the steps of the referral process.
 */
const Steps: React.FC = () => {
  const { t } = useCustomTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography variant="h4">{t('referral.steps.title')}</Typography>

      <Box
        component="ol"
        sx={{
          position: 'relative',
          paddingLeft: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          marginTop: 0,
        }}
      >
        {steps.map(step => (
          <Step key={step.titleTranslationKey} title={t(step.titleTranslationKey)} text={t(step.textTranslationKey)} />
        ))}
      </Box>
    </Box>
  )
}

export default Steps

const steps = [
  {
    titleTranslationKey: 'referral.steps.step-one.title',
    textTranslationKey: 'referral.steps.step-one.text',
  },
  {
    titleTranslationKey: 'referral.steps.step-two.title',
    textTranslationKey: 'referral.steps.step-two.text',
  },
  {
    titleTranslationKey: 'referral.steps.step-three.title',
    textTranslationKey: 'referral.steps.step-three.text',
  },
]
